<template>
  <div class="PageMyReleaseOrder">
    <h2 class="includeBtn">{{ $t("pages.wording.myReleaseOrder") }}</h2>
    <el-form label-width="150px">
      <div class="boxContain c-form searchBar">
        <!--查詢放行單-->
        <el-row :gutter="24">
          <el-col :span="10">
            <el-form-item :label="$t('pages.wording.releaseNo')"
              ><!--放行單號-->
              <el-input :placeholder="$t('pages.wording.releaseNo')" v-model.trim="searchForm.releaseNo"></el-input
              ><!--放行單號 v-model="searchForm.releaseNo"-->
            </el-form-item>
          </el-col>
          <el-col :span="11" style="max-width: 28em">
            <el-form-item :label="$t('pages.wording.salesDate')"
              ><!--出售日期-->
              <el-date-picker
                v-model="searchForm.applyDate"
                type="daterange"
                range-separator="-"
                :start-placeholder="$t('pages.wording.startDate')"
                :end-placeholder="$t('pages.wording.endDate')"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                ><!--開始日期/結束日期-->
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-button class="blue-button" @click="queryTable()" type="primary">{{
              $t("pages.button.search")
            }}</el-button
            ><!--查詢-->
          </el-col>
        </el-row>
      </div>
    </el-form>
    <div class="boxContain c-table includeBtn">
      <el-tabs v-model="activeName">
        <el-tab-pane label="inProcess" name="second">
          <span slot="label"
            ><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.inProccess") }}({{
              inProcessTableData.length
            }})</span
          ><!--處理中-->
          <div class="s-table">
            <template>
              <el-table
                :data="inProcessNewTableData"
                border
                style="width: 100%"
                height="450px"
                @current-change="viewReleaseInfo"
                @sort-change="InProcessChangeSort"
              >
                <el-table-column label="Action" width="80"
                  ><!--編輯-->
                  <template slot-scope="scope">
                    <el-button type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="120">
                </el-table-column
                ><!--放行單-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveTitle')" width="120">
                </el-table-column
                ><!--預約單-->
                <el-table-column prop="tmpCarPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    <div v-if="scope.row.tempCar">
                      {{ scope.row.tmpCarPlat }}
                    </div>
                    <div v-if="!scope.row.tempCar">
                      {{ scope.row.carPlat }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" label="OA CODE" width="120"> </el-table-column
                ><!--OA CODE-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="120"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="130" sortable>
                </el-table-column
                ><!--出售日期-->
                <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')" width="230">
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="applicatorName" :label="$t('pages.wording.applicatorName')" width="90">
                </el-table-column
                ><!--填單人-->
                <el-table-column prop="releaseOrderStatus" :label="$t('pages.wording.releaseOrderStatus')" width="170">
                  <template slot-scope="scope">
                    {{ $t("release.status." + scope.row.releaseOrderStatus) }}
                  </template> </el-table-column
                ><!--狀態-->
                <el-table-column prop="applyDate" :label="$t('pages.wording.releaseCreateDate')" width="120">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDate) }}
                  </template> </el-table-column
                ><!--開單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.inProcessTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.inProcessTablePage.pageTotal"
              @current-change="changePageInProcessTable"
            >
              >
            </el-pagination>
          </div>
          <!--s-table--> </el-tab-pane
        ><!--inProcess-->
        <el-tab-pane label="finish" name="third">
          <span slot="label"
            ><i class="el-icon-takeaway-box"></i>{{ $t("pages.wording.finish") }}({{ finishTableData.length }})</span
          ><!--已完成-->
          <div class="s-table">
            <template>
              <el-table
                :data="finishNewTableData"
                border
                style="width: 100%"
                height="450px"
                @current-change="viewReleaseInfo"
                @sort-change="FinishChangeSort"
              >
                <el-table-column label="Action" width="80"
                  ><!--編輯-->
                  <template>
                    <el-button @click="" type="text" size="medium">
                      <i class="el-icon-tickets"></i>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column prop="releaseOrderNo" :label="$t('pages.wording.releaseOrder')" width="120">
                </el-table-column
                ><!--放行單-->
                <el-table-column prop="reserveNo" :label="$t('pages.wording.reserveTitle')" width="120">
                </el-table-column
                ><!--預約單-->
                <el-table-column prop="tmpCarPlat" :label="$t('pages.wording.carPlat')" width="140"
                  ><!--車牌號碼-->
                  <template slot-scope="scope">
                    <div v-if="scope.row.tempCar">
                      {{ scope.row.tmpCarPlat }}
                    </div>
                    <div v-if="!scope.row.tempCar">
                      {{ scope.row.carPlat }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="OACode" label="OA CODE" width="120"> </el-table-column
                ><!--OA CODE-->
                <el-table-column prop="vendor" :label="$t('pages.wording.vendor')" width="120"> </el-table-column
                ><!--公司名稱-->
                <el-table-column prop="saleDate" :label="$t('pages.wording.salesDate')" width="130" sortable>
                </el-table-column
                ><!--出售日期-->
                <el-table-column prop="deltaContactName" :label="$t('pages.wording.deltaContactName')" width="230">
                </el-table-column
                ><!--台達聯絡人-->
                <el-table-column prop="applicatorName" :label="$t('pages.wording.applicatorName')" width="90">
                </el-table-column
                ><!--台達填單人-->
                <el-table-column prop="releaseOrderStatus" :label="$t('pages.wording.releaseOrderStatus')" width="170">
                  <template slot-scope="scope">
                    {{ $t("release.status." + scope.row.releaseOrderStatus) }}
                  </template> </el-table-column
                ><!--狀態-->
                <el-table-column prop="applyDate" :label="$t('pages.wording.releaseCreateDate')" width="140">
                  <template slot-scope="scope">
                    {{ formateDatetimeStr("Date", scope.row.applyDatetime) }}
                  </template> </el-table-column
                ><!--開單日期-->
              </el-table>
            </template>
            <el-pagination
              :pager-count="pages.pageCount"
              :page-size="pages.pageSize"
              :current-page.sync="pages.finishTablePage.pageCurrent"
              layout="prev, pager, next"
              :total="pages.finishTablePage.pageTotal"
              @current-change="changePageFinishTable"
            >
              >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { api } from "@/utils/api.js"
import { utils } from "@/utils/utils.js"
export default {
  name: "PageVendorReleaseOrder",
  data() {
    return {
      activeName: "second",
      searchForm: {
        releaseNo: "",
        applyDate: "",
      },
      inProcessTableData: [],
      inProcessNewTableData: [],
      finishTableData: [],
      finishNewTableData: [],
      pages: {
        pageCount: this.$global.pageCount,
        pageSize: this.$global.pageSize,
        inProcessTablePage: {
          pageTotal: 1,
          pageCurrent: 1,
        },
        finishTablePage: {
          pageTotal: 1,
          pageCurrent: 1,
        },
      },
      queryParamsAfterSubmit: {
        releaseNo: "",
        applyDate: "",
      },
      loading: false,
      preTabName: "", //keep click tab name for go back action
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.queryTable()
    },
    changePageInProcessTable(val) {
      this.inProcessNewTableData = utils.buildPagingTable(this.inProcessTableData, val, this.pages.pageSize)
    },
    changePageFinishTable(val) {
      this.finishNewTableData = utils.buildPagingTable(this.finishTableData, val, this.pages.pageSize)
    },
    InProcessChangeSort(cols) {
      utils.sortChangeMethod(cols, this.inProcessTableData)
      this.inProcessNewTableData = utils.buildPagingTable(
        this.inProcessTableData,
        this.pages.inProcessTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    FinishChangeSort(cols) {
      utils.sortChangeMethod(cols, this.finishTableData)
      this.finishNewTableData = utils.buildPagingTable(
        this.finishTableData,
        this.pages.finishTablePage.pageCurrent,
        this.pages.pageSize
      )
    },
    /***************-FORM ACTIVE-***************/
    queryTable() {
      let reserveBeginDatetime = null
      let reserveEndDatetime = null
      if (this.searchForm.applyDate === null || this.searchForm.applyDate.length === 0) {
        //deal with query setting after go back action
        const queryParamsStorage = window.sessionStorage.getItem("queryParams")
        if (queryParamsStorage && queryParamsStorage !== "null") {
          const queryParams = JSON.parse(queryParamsStorage)
          reserveBeginDatetime = utils.getISOString(utils.getDateTime(new Date(queryParams.applyDate[0]))[0] + " 00:00")
          reserveEndDatetime = utils.getISOString(utils.getDateTime(new Date(queryParams.applyDate[1]))[0] + " 23:59")
          this.preTabName = queryParams.tabName
          const preQueryReleaseNo = queryParams.releaseNo
          window.sessionStorage.removeItem("queryParams")
          this.searchForm.releaseNo = preQueryReleaseNo
        } else {
          const monthDate = utils.getMonthFirstLastDate()
          const firstDate = utils.getDateTime(monthDate[0])
          const lastDate = utils.getDateTime(monthDate[1])
          reserveBeginDatetime = utils.getISOString(firstDate[0] + " " + firstDate[1])
          reserveEndDatetime = utils.getISOString(lastDate[0] + " " + lastDate[1])
        }
        this.searchForm.applyDate = [
          utils.parseISOStringToDate(reserveBeginDatetime),
          utils.parseISOStringToDate(reserveEndDatetime),
        ]
      } else {
        reserveBeginDatetime = utils.getISOString(
          utils.getDateTime(new Date(this.searchForm.applyDate[0]))[0] + " 00:00"
        )
        reserveEndDatetime = utils.getISOString(utils.getDateTime(new Date(this.searchForm.applyDate[1]))[0] + " 23:59")
      }
      //keep query parameters after submit query
      this.queryParamsAfterSubmit.releaseNo = this.searchForm.releaseNo
      this.queryParamsAfterSubmit.applyDate = this.searchForm.applyDate

      const params = {
        releaseOrderNo: this.searchForm.releaseNo,
        reserveArriveDateTimeStart: reserveBeginDatetime,
        reserveArriveDateTimeEnd: reserveEndDatetime,
      }
      this.loading = true
      api
        .apiGetVendorReleaseTable(params)
        .then((response) => {
          let releaseData = []
          if (response.status === 200) {
            releaseData = response.data
          }
          if (releaseData.length === 0) {
            this.finishNewTableData = []
            this.inProcessNewTableData = []
            this.finishTableData = []
            this.inProcessTableData = []
          } else {
            this.finishTableData = []
            this.inProcessTableData = []

            releaseData.forEach((item) => {
              switch (item.releaseOrderStatus) {
                case "NEW":
                  break
                case "sign":
                case "in1":
                case "in2":
                  this.inProcessTableData.push(item)
                  break
                case "finished":
                case "cancel":
                  this.finishTableData.push(item)
                  break
              }
            })
          }

          this.pages.inProcessTablePage.pageTotal = this.inProcessTableData.length
          this.inProcessNewTableData = utils.buildPagingTable(
            this.inProcessTableData,
            this.pages.inProcessTablePage.pageCurrent,
            this.pages.pageSize
          )

          this.pages.finishTablePage.pageTotal = this.finishTableData.length
          this.finishNewTableData = utils.buildPagingTable(
            this.finishTableData,
            this.pages.finishTablePage.pageCurrent,
            this.pages.pageSize
          )

          this.loading = false
          //select tab after click go back from Form page
          if (this.preTabName !== "") {
            this.activeName = this.preTabName
            this.preTabName = ""
          }
        })
        .catch((error) => {
          this.loading = false
          reject(error)
        })
    },
    viewReleaseInfo(val) {
      //keep params of query for go back.
      const queryparams = {
        applyDate: this.queryParamsAfterSubmit.applyDate,
        releaseNo: this.queryParamsAfterSubmit.releaseNo,
        tabName: this.activeName,
      }
      const prevPageParams = {
        routeName: "PageVendorReleaseOrder",
        key: {},
      }
      val["queryParams"] = queryparams
      val["prevPageParams"] = prevPageParams
      this.$router.push({
        name: "PageVendorReleaseOrderInfo",
        params: val,
      })
    },
    formateDatetimeStr(type, dtstring) {
      return utils.getFormateDateTime(type, dtstring)
    },
  },
  watch: {},
}
</script>

<style>
.body .searchBar.c-form .el-row {
  line-height: normal;
}
</style>
